import axios from "axios";
import API_URL from './apiBase';


// const API_URL = "http://localhost:8080";

const axiosInstance = axios.create({ baseURL: API_URL });


// Add a request interceptor to automatically include the token
axiosInstance.interceptors.request.use((config) => {
    const jwtToken = localStorage.getItem("JWT_TOKEN");
    if (jwtToken) {
        config.headers.Authorization = `Bearer ${jwtToken}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
    (response) => {
        // Normal successful response
        return response;
    },
    (error) => {
        if (error.response) {
            // Example: backend sends JSON with error code
            const errData = error.response.data;

            // If backend sends { code: 10900, message: "Expired session" }
            if (errData?.code === 10900) {
                console.warn("Session expired, logging out...");
                localStorage.removeItem("JWT_TOKEN");
                localStorage.removeItem("LOGGED_IN");
                localStorage.removeItem("ROLE");

                // Redirect user to login
                window.location.href = "/login";
            }

            // OR if you want to check by HTTP status
            // if (error.response.status === 401) {
            //     console.warn("Unauthorized, logging out...");
            //     localStorage.clear();
            //     window.location.href = "/login";
            // }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
